import type { FaireProductEntity } from "../../entity_types/product";

export const p_73ebfdakr9: FaireProductEntity = {
  token: "p_73ebfdakr9",
  type: "product",
  name: "East Bay Breakfast",
  brandToken: "b_6su5v1sirt",
  brandName: "Highwire Coffee Roasters",
  imageUrl: "https://cdn.faire.com/fastly/79e8a661c5d9c496d8ad6eda639990f9c4c61701801829564c2c74abafefe083.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4ff726c74933b435b9801929f6b200d75c264ed5a8809e711ffa2eb347650c5c.jpeg",
    "https://cdn.faire.com/fastly/e1acb0bcbc67b6eb1dbc0ea4f774dd0c3870dc83ebcc4bb4eb9ef6a87e07298b.png"
  ],
  priceDollars: 10.5,
  description: "Profile: Bold, malty, toasty grains.\n\nIf you’re a fan of a brisk cup without any adulteration this will reward with both strength and character. We combine Ceylon, Keemun, Assam, and Yunnan black teas to draw out flavors you wouldn’t otherwise experience.\n\nProfile: Bold, malty, toasty grains.\n\nWe used to call this tea Open My Eyes for a reason. It’s a bold, fully-flavored tea that draws attention to itself right away. For those who love a strong cup with milk this will definitely do the trick. And if you’re a fan of a brisk cup without any adulteration this will reward with both strength and character. We combine Ceylon, Keemun, Assam, and Yunnan black teas to draw out flavors you wouldn’t otherwise experience. It’s full bodied and malty with a toasty finish.\n\nWe recommend brewing 1g of tea in 2oz of water at 210° for 4 minutes.",
  tags: [],
  msrpDollars: 15,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:38.983Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
